import React from "react";
import { FormattedMessage } from "react-intl";
import { withRouter, NavLink } from "react-router-dom";

/**
 * NavLink item for user Navbar
 * @param {String} link navlink to redirect
 * @param {String} formattedMessageId id to get formatted message
 */
class MenuItem extends React.Component {
  render() {
    const { link, formattedMessageId, event } = this.props;
    return (
      <React.Fragment>
        <li className="nav-item list-inline-item align-middle text-nowrap mb-3 mt-3 mb-sm-0 mt-sm-0">
          <NavLink
            className="w-100 p-3"
            to={link}
            exact
            activeClassName="selected"
            onClick={event}
          >
            <FormattedMessage id={formattedMessageId} />
          </NavLink>
        </li>
      </React.Fragment>
    );
  }
}

export default withRouter(MenuItem);
